module.exports = __webpack_public_path__ + "img/MUSA-18.543d01df.jpg";